import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import Unauthorized from './Unauthorized';

/**
* Class RouteCheck
* RouteCheck manage components rendering from permissions
**/
class RouteCheck extends Component {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.hasRoute = false;
  }

  /**
  * getUserRoutes
  * Get user permissions array from context
  **/
  getUserRoutes() {
    return (this.context.user !== null) ? this.context.user.permissions : [];
  }

  /**
  * getRoute
  * Check the permission from props
  **/
  getRoute() {

    if(this.props.component === "Allow") {
      this.hasRoute = true;
    }

    const permissions = this.getUserRoutes();

    if(permissions[this.props.component] !== undefined) {
      this.hasRoute = (permissions[this.props.component][this.props.permission] === true);
    }

    return this.hasRoute;
  }

  /**
  * render
  * Rendering component function : display or not the children
  **/
  render() {
    let routeProps = this.props.routeProps;

    if(!this.getRoute()) {
      routeProps.component = Unauthorized;
    }

    if(routeProps.path === "/") {
      routeProps.name = "accueil";
    }
    return <Route {...routeProps} />;
  }

}

RouteCheck.contextTypes = {
  user: PropTypes.object.isRequired
}

RouteCheck.propTypes = {
  component: PropTypes.string.isRequired,
  permission: PropTypes.string.isRequired,
  routeProps: PropTypes.object.isRequired
}

export default RouteCheck;



// WEBPACK FOOTER //
// ./src/views/Permissions/RouteCheck.js